import { Component, inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { CustomSnackbarData } from 'src/app/models/notifications.model';

@Component({
  selector: 'custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrl: './custom-snackbar.component.scss',
})
export class CustomSnackbarComponent {
  public snackBarRef: MatSnackBarRef<CustomSnackbarComponent> =
    inject(MatSnackBarRef);

  public data: CustomSnackbarData = inject(MAT_SNACK_BAR_DATA);
}
